function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { VuetifyWidgetModel } from './VuetifyWidget';
export class FlexModel extends VuetifyWidgetModel {
  defaults() {
    return _objectSpread({}, super.defaults(), {
      _model_name: 'FlexModel',
      xs1: null,
      xs2: null,
      xs3: null,
      xs4: null,
      xs5: null,
      xs6: null,
      xs7: null,
      xs8: null,
      xs9: null,
      xs10: null,
      xs11: null,
      xs12: null,
      sm1: null,
      sm2: null,
      sm3: null,
      sm4: null,
      sm5: null,
      sm6: null,
      sm7: null,
      sm8: null,
      sm9: null,
      sm10: null,
      sm11: null,
      sm12: null,
      md1: null,
      md2: null,
      md3: null,
      md4: null,
      md5: null,
      md6: null,
      md7: null,
      md8: null,
      md9: null,
      md10: null,
      md11: null,
      md12: null,
      lg1: null,
      lg2: null,
      lg3: null,
      lg4: null,
      lg5: null,
      lg6: null,
      lg7: null,
      lg8: null,
      lg9: null,
      lg10: null,
      lg11: null,
      lg12: null,
      xl1: null,
      xl2: null,
      xl3: null,
      xl4: null,
      xl5: null,
      xl6: null,
      xl7: null,
      xl8: null,
      xl9: null,
      xl10: null,
      xl11: null,
      xl12: null,
      align_self_baseline: null,
      align_self_center: null,
      align_self_end: null,
      align_self_start: null,
      grow: null,
      id: null,
      offset_xs0: null,
      offset_xs1: null,
      offset_xs2: null,
      offset_xs3: null,
      offset_xs4: null,
      offset_xs5: null,
      offset_xs6: null,
      offset_xs7: null,
      offset_xs8: null,
      offset_xs9: null,
      offset_xs10: null,
      offset_xs11: null,
      offset_xs12: null,
      offset_sm0: null,
      offset_sm1: null,
      offset_sm2: null,
      offset_sm3: null,
      offset_sm4: null,
      offset_sm5: null,
      offset_sm6: null,
      offset_sm7: null,
      offset_sm8: null,
      offset_sm9: null,
      offset_sm10: null,
      offset_sm11: null,
      offset_sm12: null,
      offset_md0: null,
      offset_md1: null,
      offset_md2: null,
      offset_md3: null,
      offset_md4: null,
      offset_md5: null,
      offset_md6: null,
      offset_md7: null,
      offset_md8: null,
      offset_md9: null,
      offset_md10: null,
      offset_md11: null,
      offset_md12: null,
      offset_lg0: null,
      offset_lg1: null,
      offset_lg2: null,
      offset_lg3: null,
      offset_lg4: null,
      offset_lg5: null,
      offset_lg6: null,
      offset_lg7: null,
      offset_lg8: null,
      offset_lg9: null,
      offset_lg10: null,
      offset_lg11: null,
      offset_lg12: null,
      offset_xl0: null,
      offset_xl1: null,
      offset_xl2: null,
      offset_xl3: null,
      offset_xl4: null,
      offset_xl5: null,
      offset_xl6: null,
      offset_xl7: null,
      offset_xl8: null,
      offset_xl9: null,
      offset_xl10: null,
      offset_xl11: null,
      offset_xl12: null,
      order_xs1: null,
      order_xs2: null,
      order_xs3: null,
      order_xs4: null,
      order_xs5: null,
      order_xs6: null,
      order_xs7: null,
      order_xs8: null,
      order_xs9: null,
      order_xs10: null,
      order_xs11: null,
      order_xs12: null,
      order_sm1: null,
      order_sm2: null,
      order_sm3: null,
      order_sm4: null,
      order_sm5: null,
      order_sm6: null,
      order_sm7: null,
      order_sm8: null,
      order_sm9: null,
      order_sm10: null,
      order_sm11: null,
      order_sm12: null,
      order_md1: null,
      order_md2: null,
      order_md3: null,
      order_md4: null,
      order_md5: null,
      order_md6: null,
      order_md7: null,
      order_md8: null,
      order_md9: null,
      order_md10: null,
      order_md11: null,
      order_md12: null,
      order_lg1: null,
      order_lg2: null,
      order_lg3: null,
      order_lg4: null,
      order_lg5: null,
      order_lg6: null,
      order_lg7: null,
      order_lg8: null,
      order_lg9: null,
      order_lg10: null,
      order_lg11: null,
      order_lg12: null,
      order_xl1: null,
      order_xl2: null,
      order_xl3: null,
      order_xl4: null,
      order_xl5: null,
      order_xl6: null,
      order_xl7: null,
      order_xl8: null,
      order_xl9: null,
      order_xl10: null,
      order_xl11: null,
      order_xl12: null,
      shrink: null,
      tag: null,
      mt_auto: null,
      mt_0: null,
      mt_1: null,
      mt_2: null,
      mt_3: null,
      mt_4: null,
      mt_5: null,
      mb_auto: null,
      mb_0: null,
      mb_1: null,
      mb_2: null,
      mb_3: null,
      mb_4: null,
      mb_5: null,
      ml_auto: null,
      ml_0: null,
      ml_1: null,
      ml_2: null,
      ml_3: null,
      ml_4: null,
      ml_5: null,
      mr_auto: null,
      mr_0: null,
      mr_1: null,
      mr_2: null,
      mr_3: null,
      mr_4: null,
      mr_5: null,
      mx_auto: null,
      mx_0: null,
      mx_1: null,
      mx_2: null,
      mx_3: null,
      mx_4: null,
      mx_5: null,
      my_auto: null,
      my_0: null,
      my_1: null,
      my_2: null,
      my_3: null,
      my_4: null,
      my_5: null,
      ma_auto: null,
      ma_0: null,
      ma_1: null,
      ma_2: null,
      ma_3: null,
      ma_4: null,
      ma_5: null,
      pt_auto: null,
      pt_0: null,
      pt_1: null,
      pt_2: null,
      pt_3: null,
      pt_4: null,
      pt_5: null,
      pb_auto: null,
      pb_0: null,
      pb_1: null,
      pb_2: null,
      pb_3: null,
      pb_4: null,
      pb_5: null,
      pl_auto: null,
      pl_0: null,
      pl_1: null,
      pl_2: null,
      pl_3: null,
      pl_4: null,
      pl_5: null,
      pr_auto: null,
      pr_0: null,
      pr_1: null,
      pr_2: null,
      pr_3: null,
      pr_4: null,
      pr_5: null,
      px_auto: null,
      px_0: null,
      px_1: null,
      px_2: null,
      px_3: null,
      px_4: null,
      px_5: null,
      py_auto: null,
      py_0: null,
      py_1: null,
      py_2: null,
      py_3: null,
      py_4: null,
      py_5: null,
      pa_auto: null,
      pa_0: null,
      pa_1: null,
      pa_2: null,
      pa_3: null,
      pa_4: null,
      pa_5: null
    });
  }

  getVueTag() {
    // eslint-disable-line class-methods-use-this
    return 'v-flex';
  }

}
FlexModel.serializers = _objectSpread({}, VuetifyWidgetModel.serializers);